<div class="language-item">
    <div class="language-item-flag language-item-flag--{{ code }}" *ngIf="showFlag"></div>
    <div class="language-item-name">{{ name }}</div>
</div>
